"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import DataBuilderCondition from './Condition/index.mjs';
import { DataBuilderProvider } from './data-builder-context.mjs';
import classes from './styles.module.css.mjs';
import { makeDataField } from './index.mjs';

function DataBuilderFilter({
  value,
  variablesSchema,
  onChange
}) {
  const field = makeDataField({
    value,
    variablesSchema
  });
  return /* @__PURE__ */ jsx(DataBuilderProvider, { topLevelField: field, children: /* @__PURE__ */ jsx("div", { className: classes.wrapper, children: /* @__PURE__ */ jsx(DataBuilderCondition, { field, onChange }) }) });
}

export { DataBuilderFilter };
